import { Fragment } from "react";
import { APP_DEVELOPED_BY, APP_NAME } from "../../Config/Config";
import React from "react";
function Footer() {
    return (
        <Fragment>
            <footer className="footer">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-6">
                            <div className="ProjectNamefooter"><script>document.write(new Date().getFullYear())</script> ©{APP_NAME}.</div>
                        </div>
                        <div className="col-sm-6">
                            <div className="text-sm-end d-none d-sm-block">
                                {/* Crafted with <i className="mdi mdi-heart text-danger"></i> by {APP_DEVELOPED_BY} */}
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </Fragment>
    );
}

export default Footer;